@if(dokumentUrl$ | async; as url){

    @if(url.url) {
        <h1>Dokument hämtas...</h1>
        <span>
            Ditt dokument håller nu på att hämtas. Om det inte laddar automatiskt
            <a [href]="url.url" target="_blank">klicka här</a>
        </span>
    } @else {
        <h2>{{url.meddelande}}</h2>
    }
}
@else{
    <h2>Fel vid hämtning av dokument</h2>
}